import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-tpn-open-batch-modal',
  templateUrl: './edit-tpn-open-batch-modal.component.html',
  styleUrls: ['./edit-tpn-open-batch-modal.component.scss']
})
export class EditTpnOpenBatchModalComponent implements OnInit {

  @Input() tpn: string;
  @Input() route: string='back';
  @Input() routeParam = {};
  queryParam = {};

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {

    this.queryParam = {tpn: this.tpn,route:this.route,...this.routeParam};
    

  }

}
